import React from 'react';
import { User } from '../types';
import { Mail, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AccountPageProps {
  user: User;
}

export const AccountPage: React.FC<AccountPageProps> = ({ user }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-rutabaga-bg">
      {/* Header with back button */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-2xl mx-auto px-4 py-4">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-rutabaga-wood hover:text-rutabaga-woodDark transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Back to Dashboard</span>
          </button>
        </div>
      </div>

      {/* Account content */}
      <div className="max-w-2xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-heading font-bold text-rutabaga-text mb-8">
          My Account
        </h1>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          {/* Avatar section */}
          <div className="p-8 flex flex-col items-center border-b border-gray-100">
            <img
              src={user.avatar}
              alt={user.name}
              className="w-24 h-24 rounded-full object-cover border-4 border-rutabaga-wood mb-4"
              referrerPolicy="no-referrer"
            />
            <h2 className="text-xl font-bold text-rutabaga-text">{user.name}</h2>
          </div>

          {/* Email section */}
          <div className="p-6">
            <div className="flex items-center gap-3 text-gray-600">
              <Mail size={20} className="text-rutabaga-wood" />
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="text-rutabaga-text font-medium">{user.email}</p>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-sm text-gray-400 mt-6">
          Signed in with Google
        </p>
      </div>
    </div>
  );
};
